import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EmptyListRobotIcon } from 'atoms/icons/svg/empty-list-robot.svg';
import './NoResult.scss';

const NoResult: FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box className="daviation-no-result">
      <EmptyListRobotIcon />
      <div className="info">
        <span className="info-title">
          {t('Everything is fine with the cages.')}
        </span>
        <Typography className="info-description">
          {t('We have not detected any deviations.')}
        </Typography>
      </div>
    </Box>
  );
};

export default NoResult;
